module.exports = fox._r("images/promo/icon-fb.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/icon-fb.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/icon-fb.png
// module id = 164
// module chunks = 2